import axiosClient from "..";
import { getErrorMessageObj } from "../../../container/SportsBookNode/utils/common/functions";

export default class ExtraMarketsService {
  static getSingleMatch(params) {
    return axiosClient
      .get("/sb/singleEvent", {
        params
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }
  static getExtraMarkets(params) {
    return axiosClient
      .get("/sb/getMarkets", {
        params
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }
}
